/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundRef,
  DonationFundRefOptional,
  DonationFundRefMetaI,
  DonationFundRefTrackedI,
} from "./donation-fund-ref";
import {
  DonationFundRefTracked,
  DonationFundRefMeta,
} from "./donation-fund-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationInitiativeBase,
  DonationInitiativeBaseOptional,
  DonationInitiativeBaseMetaI,
  DonationInitiativeBaseTrackedI,
} from "./donation-initiative-base";
import {
  DonationInitiativeBaseTracked,
  DonationInitiativeBaseMeta,
} from "./donation-initiative-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationInitiativeRef,
  DonationInitiativeRefOptional,
  DonationInitiativeRefMetaI,
  DonationInitiativeRefTrackedI,
} from "./donation-initiative-ref";
import {
  DonationInitiativeRefTracked,
  DonationInitiativeRefMeta,
} from "./donation-initiative-ref";

/**
 *
 * @export
 * @interface DonationInitiativeFull
 */
export interface DonationInitiativeFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  initiativeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isFeatured?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isGoalPublic?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  contributionsGoal?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeFull
   */
  targetFund?: DonationFundRefOptional;
}

export interface DonationInitiativeFull
  extends
    DonationInitiativeFullOptional,
    Deletable,
    DonationInitiativeBase,
    DonationInitiativeRef {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  initiativeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isFeatured?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isGoalPublic?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  contributionsGoal?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeFull
   */
  targetFund?: DonationFundRef;
}

export interface DonationInitiativeFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  showInCheckout?: boolean;
  showInCheckoutIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  portalDescription?: string;
  portalDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeFull
   */
  initiativeName?: string;
  initiativeNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isFeatured?: boolean;
  isFeaturedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeFull
   */
  isGoalPublic?: boolean;
  isGoalPublicIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeFull
   */
  contributionsGoal?: number;
  contributionsGoalIsSet: boolean;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeFull
   */
  targetFund?: DonationFundRefTrackedI;
  targetFundIsSet: boolean;
}

transformDatesMap.set(
  "DonationInitiativeFull",
  function (model: DonationInitiativeFull) {
    const transformDatestargetFund = transformDatesMap.get("DonationFundRef");
    if (transformDatestargetFund && model.targetFund) {
      transformDatestargetFund(model.targetFund);
    }
  },
);

export type DonationInitiativeFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  showInCheckout: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  portalDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  initiativeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isFeatured: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isGoalPublic: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  contributionsGoal: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  targetFund: PropertyMeta<DonationFundRefMetaI>;
}>;

export var DonationInitiativeFullMeta: DonationInitiativeFullMetaI =
  {} as DonationInitiativeFullMetaI;
DonationInitiativeFullMeta = typeMeta("DonationInitiativeFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  showInCheckout: propertyMeta(
    "showInCheckout",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  portalDescription: propertyMeta(
    "portalDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  initiativeName: propertyMeta(
    "initiativeName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isFeatured: propertyMeta(
    "isFeatured",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isGoalPublic: propertyMeta(
    "isGoalPublic",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  contributionsGoal: propertyMeta(
    "contributionsGoal",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  targetFund: propertyMeta(
    "targetFund",
    false,
    false,
    false,
    DonationFundRefMeta,
  ),
});

const metaI = DonationInitiativeFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DonationInitiativeRefMeta]);
  metaI.assignId.inheritedFrom = DonationInitiativeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([DonationInitiativeBaseMeta]);
  metaI.active.inheritedFrom = DonationInitiativeBaseMeta.active;
  metaI.displayOrder.inheritedFrom = DonationInitiativeBaseMeta.displayOrder;
  metaI.showInCheckout.inheritedFrom =
    DonationInitiativeBaseMeta.showInCheckout;
  metaI.portalDescription.inheritedFrom =
    DonationInitiativeBaseMeta.portalDescription;
  metaI.imageURL.inheritedFrom = DonationInitiativeBaseMeta.imageURL;
  metaI.initiativeName.inheritedFrom =
    DonationInitiativeBaseMeta.initiativeName;
  metaI.isFeatured.inheritedFrom = DonationInitiativeBaseMeta.isFeatured;
  metaI.isGoalPublic.inheritedFrom = DonationInitiativeBaseMeta.isGoalPublic;
  metaI.contributionsGoal.inheritedFrom =
    DonationInitiativeBaseMeta.contributionsGoal;
  metaI.targetFund.inheritedFrom = DonationInitiativeBaseMeta.targetFund;
});

export class DonationInitiativeFullTracked
  extends DeletableTracked
  implements DonationInitiativeFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  showInCheckout__I?: boolean = undefined;
  showInCheckoutIsSet: boolean = false;
  set showInCheckout(v: undefined | boolean) {
    if (v !== undefined) {
      this.showInCheckout__I = v;
      this.showInCheckoutIsSet = true;
    } else {
      this.showInCheckout__I = v || undefined;
      this.showInCheckoutIsSet = false;
    }
    this.changeTracker = true;
  }
  get showInCheckout() {
    return this.showInCheckout__I;
  }
  portalDescription__I?: string = undefined;
  portalDescriptionIsSet: boolean = false;
  set portalDescription(v: undefined | string) {
    if (v !== undefined) {
      this.portalDescription__I = v;
      this.portalDescriptionIsSet = true;
    } else {
      this.portalDescription__I = v || undefined;
      this.portalDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get portalDescription() {
    return this.portalDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  initiativeName__I?: string = undefined;
  initiativeNameIsSet: boolean = false;
  set initiativeName(v: undefined | string) {
    if (v !== undefined) {
      this.initiativeName__I = v;
      this.initiativeNameIsSet = true;
    } else {
      this.initiativeName__I = v || undefined;
      this.initiativeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get initiativeName() {
    return this.initiativeName__I;
  }
  isFeatured__I?: boolean = undefined;
  isFeaturedIsSet: boolean = false;
  set isFeatured(v: undefined | boolean) {
    if (v !== undefined) {
      this.isFeatured__I = v;
      this.isFeaturedIsSet = true;
    } else {
      this.isFeatured__I = v || undefined;
      this.isFeaturedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isFeatured() {
    return this.isFeatured__I;
  }
  isGoalPublic__I?: boolean = undefined;
  isGoalPublicIsSet: boolean = false;
  set isGoalPublic(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGoalPublic__I = v;
      this.isGoalPublicIsSet = true;
    } else {
      this.isGoalPublic__I = v || undefined;
      this.isGoalPublicIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGoalPublic() {
    return this.isGoalPublic__I;
  }
  contributionsGoal__I?: number = undefined;
  contributionsGoalIsSet: boolean = false;
  set contributionsGoal(v: undefined | number) {
    if (v !== undefined) {
      this.contributionsGoal__I = v;
      this.contributionsGoalIsSet = true;
    } else {
      this.contributionsGoal__I = v || undefined;
      this.contributionsGoalIsSet = false;
    }
    this.changeTracker = true;
  }
  get contributionsGoal() {
    return this.contributionsGoal__I;
  }
  targetFund__I?: DonationFundRefTracked = undefined;
  targetFundIsSet: boolean = false;
  set targetFund(v: undefined | DonationFundRefTracked) {
    if (v !== undefined) {
      this.targetFund__I = v;
      this.targetFundIsSet = true;
    } else {
      this.targetFund__I = v || undefined;
      this.targetFundIsSet = false;
    }
    this.changeTracker = true;
  }
  get targetFund() {
    return this.targetFund__I;
  }
  constructor(
    config?: DonationInitiativeFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.targetFund?.setIds();
  }
  assignFrom(
    config: DonationInitiativeFullOptional,
    options?: AssignOptions,
  ): DonationInitiativeFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.showInCheckout &&
      this.showInCheckoutApplyFilter(optionsRequired.filter)
    ) {
      this.showInCheckout = config.showInCheckout;
      if (optionsRequired.unassign) this.showInCheckoutIsSet = false;
      else this.showInCheckoutIsSet = true;
    }
    if (
      config.portalDescription &&
      this.portalDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.portalDescription = config.portalDescription;
      if (optionsRequired.unassign) this.portalDescriptionIsSet = false;
      else this.portalDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (
      config.initiativeName &&
      this.initiativeNameApplyFilter(optionsRequired.filter)
    ) {
      this.initiativeName = config.initiativeName;
      if (optionsRequired.unassign) this.initiativeNameIsSet = false;
      else this.initiativeNameIsSet = true;
    }
    if (
      config.isFeatured &&
      this.isFeaturedApplyFilter(optionsRequired.filter)
    ) {
      this.isFeatured = config.isFeatured;
      if (optionsRequired.unassign) this.isFeaturedIsSet = false;
      else this.isFeaturedIsSet = true;
    }
    if (
      config.isGoalPublic &&
      this.isGoalPublicApplyFilter(optionsRequired.filter)
    ) {
      this.isGoalPublic = config.isGoalPublic;
      if (optionsRequired.unassign) this.isGoalPublicIsSet = false;
      else this.isGoalPublicIsSet = true;
    }
    if (
      config.contributionsGoal &&
      this.contributionsGoalApplyFilter(optionsRequired.filter)
    ) {
      this.contributionsGoal = config.contributionsGoal;
      if (optionsRequired.unassign) this.contributionsGoalIsSet = false;
      else this.contributionsGoalIsSet = true;
    }
    if (
      config.targetFund &&
      this.targetFundApplyFilter(optionsRequired.filter)
    ) {
      this.targetFund = new DonationFundRefTracked(config.targetFund, options);
      if (optionsRequired.unassign) this.targetFundIsSet = false;
      else this.targetFundIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationInitiativeFullTrackedI {
    const cloned = {} as DonationInitiativeFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.showInCheckoutIsSetDeep() &&
      this.showInCheckoutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.showInCheckoutIsSet = true;
      cloned.showInCheckout = this.showInCheckout;
    } else {
      //cloned.showInCheckoutIsSet = false
    }
    if (
      this.portalDescriptionIsSetDeep() &&
      this.portalDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.portalDescriptionIsSet = true;
      cloned.portalDescription = this.portalDescription;
    } else {
      //cloned.portalDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.initiativeNameIsSetDeep() &&
      this.initiativeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.initiativeNameIsSet = true;
      cloned.initiativeName = this.initiativeName;
    } else {
      //cloned.initiativeNameIsSet = false
    }
    if (
      this.isFeaturedIsSetDeep() &&
      this.isFeaturedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isFeaturedIsSet = true;
      cloned.isFeatured = this.isFeatured;
    } else {
      //cloned.isFeaturedIsSet = false
    }
    if (
      this.isGoalPublicIsSetDeep() &&
      this.isGoalPublicApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGoalPublicIsSet = true;
      cloned.isGoalPublic = this.isGoalPublic;
    } else {
      //cloned.isGoalPublicIsSet = false
    }
    if (
      this.contributionsGoalIsSetDeep() &&
      this.contributionsGoalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.contributionsGoalIsSet = true;
      cloned.contributionsGoal = this.contributionsGoal;
    } else {
      //cloned.contributionsGoalIsSet = false
    }
    if (
      this.targetFundIsSetDeep() &&
      this.targetFundApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetFundIsSet = true;
      cloned.targetFund = this.targetFund?.removeUnset(filter);
    } else {
      //cloned.targetFundIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationInitiativeFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.showInCheckoutApplyFilter(filter))
      this.showInCheckoutIsSet = false;

    if (!this.portalDescriptionApplyFilter(filter))
      this.portalDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.initiativeNameApplyFilter(filter))
      this.initiativeNameIsSet = false;

    if (!this.isFeaturedApplyFilter(filter)) this.isFeaturedIsSet = false;

    if (!this.isGoalPublicApplyFilter(filter)) this.isGoalPublicIsSet = false;

    if (!this.contributionsGoalApplyFilter(filter))
      this.contributionsGoalIsSet = false;

    if (!this.targetFundApplyFilter(filter)) this.targetFundIsSet = false;
    this.targetFund?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.isDeleted,
      DonationInitiativeFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.isNew,
      DonationInitiativeFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.assignId,
      DonationInitiativeFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.active,
      DonationInitiativeFullMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.displayOrder,
      DonationInitiativeFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  showInCheckoutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.showInCheckout,
      DonationInitiativeFullMeta,
      this.showInCheckout,
      this,
    );
  }
  showInCheckoutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.showInCheckoutIsSet && this.showInCheckoutApplyFilter(filter))
      return true;

    return false;
  }
  portalDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.portalDescription,
      DonationInitiativeFullMeta,
      this.portalDescription,
      this,
    );
  }
  portalDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.portalDescriptionIsSet &&
      this.portalDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.imageURL,
      DonationInitiativeFullMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  initiativeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.initiativeName,
      DonationInitiativeFullMeta,
      this.initiativeName,
      this,
    );
  }
  initiativeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.initiativeNameIsSet && this.initiativeNameApplyFilter(filter))
      return true;

    return false;
  }
  isFeaturedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.isFeatured,
      DonationInitiativeFullMeta,
      this.isFeatured,
      this,
    );
  }
  isFeaturedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isFeaturedIsSet && this.isFeaturedApplyFilter(filter)) return true;

    return false;
  }
  isGoalPublicApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.isGoalPublic,
      DonationInitiativeFullMeta,
      this.isGoalPublic,
      this,
    );
  }
  isGoalPublicIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGoalPublicIsSet && this.isGoalPublicApplyFilter(filter))
      return true;

    return false;
  }
  contributionsGoalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.contributionsGoal,
      DonationInitiativeFullMeta,
      this.contributionsGoal,
      this,
    );
  }
  contributionsGoalIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.contributionsGoalIsSet &&
      this.contributionsGoalApplyFilter(filter)
    )
      return true;

    return false;
  }
  targetFundApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeFullMeta.targetFund,
      DonationInitiativeFullMeta,
      this.targetFund,
      this,
    );
  }
  targetFundIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetFundIsSet && this.targetFundApplyFilter(filter)) return true;
    return this.targetFund?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.showInCheckoutIsSetDeep(filter)) return true;
    if (this.portalDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.initiativeNameIsSetDeep(filter)) return true;
    if (this.isFeaturedIsSetDeep(filter)) return true;
    if (this.isGoalPublicIsSetDeep(filter)) return true;
    if (this.contributionsGoalIsSetDeep(filter)) return true;
    if (this.targetFundIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
